import RegionsAll from "../components/regions/RegionsAll";
import AddNewRegion from "../components/regions/AddNewRegion";
import Countries from "../components/regions/Countries";
import RegionsSelector from "../components/regions/RegionsSelector";
import apiRegions from '../api/regions';

import { useDispatch, useSelector } from "react-redux";

import { useEffect, useState } from 'react';

import { regions as actionsRegions } from "../store/actions";

const { getRegions } = actionsRegions;

const Regions = () => {

    const dispatch = useDispatch();

    let selectedStateRegion = useSelector(store => store.regions.selectedRegion);

    const [selectedRegion, setSelectedRegion] = useState(null);
    const [trigger, setTrigger] = useState(0);

    useEffect(() => {
        dispatch(getRegions());
    }, []);

    useEffect(() => {
        if (selectedStateRegion.id > -1) {
            if (! selectedRegion) setSelectedRegion({ ...selectedStateRegion });
        }
    }, [selectedStateRegion]);

    const moveCountry = (country, regionTo, regionFrom) => {
        if (regionFrom.id == regionTo.id) {
            alert("Both regions are the same");
            return;
        }
        let proceed = window.confirm(`Move country ${country.name} from ${regionFrom.name} to ${regionTo.name}?`);
        if (proceed) {
            apiRegions.moveCountry(country.id, regionTo.id).then(() => {
                setTrigger(new Date());
            });
        }
    };

    return (

        <div className="flex flex-wrap -mx-2 sm:-mx-4 md:-mx-6 lg:-mx-1">

            <div className="my-2 px-2 w-1/3 overflow-hidden sm:my-4 sm:px-4 md:my-6 md:px-6 lg:my-1 lg:px-1" style={{position: "relative", top: 46}}>
                <RegionsAll fxOnRegionSelect={r => setSelectedRegion(r)} selectedRegion={selectedRegion} />
                <div className="mb-2"></div>
                <AddNewRegion />
            </div>

            <div className="my-2 px-2 w-1/3 overflow-hidden sm:my-4 sm:px-4 md:my-6 md:px-6 lg:my-1 lg:px-1" style={{position: "relative", top: 46}}>
                {
                    selectedRegion && 
                    <Countries region={selectedRegion} title={`Countries of ${selectedRegion.name}`} type="left" fxAction={country => moveCountry(country, selectedStateRegion, selectedRegion)} key={trigger}/>
                }
            </div>

            <div className="my-2 px-2 w-1/3 overflow-hidden sm:my-4 sm:px-4 md:my-6 md:px-6 lg:my-1 lg:px-1">
            {
                <>
                    <RegionsSelector /> 
                    <Countries region={selectedStateRegion} title={`Countries of ${selectedStateRegion.name}`} type="right" fxAction={country => moveCountry(country, selectedRegion, selectedStateRegion)} key={trigger} />
                </> 
            }
            </div>

        </div>

    );
}

export default Regions;